import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from '@mui/material';
import { useStyles } from '../styles';
import NavigationDropdown, { NavigationOption } from 'modules/views/shared/NavigationDropdown';

export const CourseHeader: React.FC = () => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <Box className={classes.header} data-testid="courses-header">
      <p className={classes.title} data-testid="courses-title">
        {t('courses.title')}
      </p>
      <NavigationDropdown excludeOptions={[NavigationOption.MY_COURSES]} />
    </Box>
  );
};
